import Transformer from './transformer';

export default class ProviderSubtypeTransformer extends Transformer {
  static fetch(subtype) {
    return {
      id: subtype.id,
      name_en: this.getLangName(subtype.name, 'en'),
      name_th: this.getLangName(subtype.name, 'th'),
      parent_id: subtype.parent_id,
      parent: subtype.parent ? this.parentProviderType(subtype.parent) : {},
      created_at: subtype.created_at,
      updated_at: subtype.updated_at,
      description_en: this.getLangName(subtype.description, 'en'),
      description_th: this.getLangName(subtype.description, 'th'),
    };
  }

  static parentProviderType(parent) {
    return {
      id: parent.id,
      name_en: this.getLangName(parent.name, 'en'),
      name_th: this.getLangName(parent.name, 'th'),
      description_en: this.getLangName(parent.description, 'en'),
      description_th: this.getLangName(parent.description, 'th'),
      created_at: parent.created_at,
      updated_at: parent.updated_at,
    };
  }

  static getLangName(name, lang) {
    const nameObject = JSON.parse(name);

    return lang === 'en' ? nameObject.en : nameObject.th;
  }
}
